import { render, staticRenderFns } from "./bomComponent.vue?vue&type=template&id=74294122&scoped=true&"
import script from "./bomComponent.vue?vue&type=script&lang=js&"
export * from "./bomComponent.vue?vue&type=script&lang=js&"
import style0 from "./bomComponent.vue?vue&type=style&index=0&id=74294122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74294122",
  null
  
)

export default component.exports